import { createContext, useContext } from "react";

export const DesktopContext = createContext({});

export const useDesktop = () => {
    const desktop = useContext(DesktopContext);
    return desktop;
};

export const PanelContext = createContext({});

export const usePanel = () => {
    const panel = useContext(PanelContext);
    return panel;
};

export const getWidth = (width, delta = 0) => {
    if (width === undefined) {
        return undefined;
    } else if (width > 1200 + delta) {
        return 'wide';
    } else if (width > 800 - delta) {
        return 'medium';
    }
    return 'narrow';
};

export const layoutInvalid = (width, layout, delta = 0) => {
    const layoutWidth = getWidth(width, delta);
    switch (layoutWidth) {
        case undefined:
            return false;
        case 'wide':
            return layout.wide === false;
        case 'medium':
            return layout.medium === false;
        case 'narrow':
            return layout.narrow === false;
        default:
            throw new Error('Unknown width ' + layoutWidth);
    }
};

export const getValidLayouts = (width, layouts, delta = 0) => {
    return layouts.filter(layout => !layoutInvalid(width, layout, delta));
};

